import React from "react";
// Drawer head icons
import newKwaakaLogo from "@src/assets/icons/newKwaakaLogo.svg";
import MenuIcon from "@src/assets/icons/menu.svg";

// Navigation icons
import { ReactComponent as NavLocationIcon } from "@src/assets/icons/navLocation.svg";
import { ReactComponent as NavMenuIcon } from "@src/assets/icons/navMenu.svg";
import { ReactComponent as NavOrderIcon } from "@src/assets/icons/navOrder.svg";
import { ReactComponent as NavStopIcon } from "@src/assets/icons/navStop.svg";
import { ReactComponent as NavSettingsIcon } from "@src/assets/icons/settings.svg";
import { ReactComponent as AnalyticsIcon } from "@src/assets/icons/analytics.svg";

import { routes } from "@src/shared/routes";
import { roles } from "@src/shared/roles";

import data from "@src/data/data.json";
import { Navigation } from "./types";

export const drawerHead = {
  menu: MenuIcon,
  kwaaka: newKwaakaLogo,
};

export const getPrivateNavigations = (language: LanguageItem): Navigation[] => {
  const navigationArray = [];

  navigationArray.push({
    id: 0,
    name: data[language].Sidebar.Analytics.Title,
    icon: <AnalyticsIcon />,
    to: routes.analytics,
    role: roles.analytics,
  });

  return [
    ...navigationArray,
    {
      id: 1,
      name: data[language].Sidebar.Orders.Title,
      icon: <NavOrderIcon />,
      to: routes.order,
      role: roles.order,
      nav: "global",
    },
    {
      id: 2,
      name: data[language].Sidebar.StopList.Title,
      icon: <NavStopIcon />,
      to: routes.stopList,
      subNav: [
        {
          id: 16,
          name: data[language].Sidebar.StopList.SubItems.Cron,
          to: routes.cron,
          role: roles.cron,
        },
        {
          id: 19,
          name: data[language].Sidebar.StopList.SubItems.Limit,
          to: routes.stopListBalance,
          role: roles.stopListBalance,
        },
      ],
      role: roles.stopList,
    },
    {
      id: 3,
      name: data[language].Sidebar.Menu.Title,
      icon: <NavMenuIcon />,
      to: routes.menu,
      subNav: [
        {
          id: 13,
          name: data[language].Menu.ConfigureMenu.ConfigureMenuHeader.Title,
          to: routes.menu,
          role: roles.menu,
        },
        {
          id: 14,
          name: data[language].Promos.PageHeader.Title,
          to: routes.promo,
          role: roles.promo,
        },
      ],
      role: roles.menu,
    },
    {
      id: 4,
      name: data[language].Sidebar.Locations.Title,
      icon: <NavLocationIcon />,
      to: routes.location,
      role: roles.location,
    },
    {
      id: 5,
      name: data[language].Sidebar.Settings.Title,
      icon: <NavSettingsIcon />,
      role: roles.timeSetting,
      to: routes.timeSetting,
      subNav: [
        {
          id: 11,
          name: data[language].Sidebar.Settings.SubItems.RestaurantSettings,
          to: routes.timeSetting,
          role: roles.timeSetting,
        },
        {
          id: 12,
          name: data[language].Sidebar.Settings.SubItems.POSsettings,
          to: routes.posSettings,
          role: roles.posSettings,
        },
        {
          id: 15,
          name: "Доступы",
          to: routes.access,
          role: roles.access,
        },
      ],
    },
    {
      id: 6,
      name: data[language].Sidebar.Callcenter.Title,
      icon: <NavOrderIcon />,
      to: routes.callCenter,
      role: roles.callCenter,
    },
  ];
};
